// example theme file
const theme = {
    colors: {
      text: '#000',
      background: '#fff',
    },
  }
  
  export default theme